/*eslint-disable multiline-ternary */
import { useRef, useState } from 'react';
import { Accordion, Row, Col } from 'react-bootstrap';
import {
  AccordionDownArrow,
  ProviderDetailedWomen,
  ProviderDetailedMen,
  ProviderImageUnknownGender,
  AccordionUpArrow,
} from '../../../../../img/findcare/FindCareSVG';
import AffiliationsAwardsAccordion from './AffiliationsAwardsAccordion';
import ProviderInformationAccordion from './ProviderInformationAccordion';
import { t } from 'i18next';

const ProviderDetailsMobile = ({
  locationHandler,
  affiliatedDoctorsHandler,
  doctorDetails,
  addressIndex,
  affiliatedDoctorsAddress,
}) => {
  const noDataMessage = t('find_provider.data_not_available');
  const [activeId, setActiveId] = useState('0');
  const affiliationsAccordion = useRef();
  const affiliationTabRef = useRef(1);

  const toggleActive = (id) => {
    if (activeId === id) {
      setActiveId(null);
    } else {
      setTimeout(() => {
        if (affiliationTabRef && affiliationTabRef?.current) {
          affiliationTabRef?.current?.focus();
        }
      }, 100);
      setActiveId(id);
    }
  };

  const makeAffiliationsActive = () => {
    affiliationsAccordion.current.click();
  };

  return (
    <>
      <Row className="top-mobile-section secondary-background p-2 py-4 py-md-2 mt-4 mb-4 mx-0 w-100">
        <Col className="col-3 p-0 pr-2">
          <div className="profile-image">
            {doctorDetails.Gender === 'Female' && (
              <ProviderDetailedWomen
                circleClassName="provider-details-profile-circle"
                className="provider-details-profile-image"
              />
            )}
            {doctorDetails.Gender === 'Male' && (
              <ProviderDetailedMen
                circleClassName="provider-details-profile-circle"
                className="provider-details-profile-image"
              />
            )}
            {(!doctorDetails.Gender || doctorDetails.Gender === 'Unknown') && (
              <ProviderImageUnknownGender
                circleClassName="provider-details-profile-circle"
                className="provider-details-profile-image"
              />
            )}
          </div>
        </Col>
        <Col className="col-9 p-0">
          <div className="other-info">
            <p className="paragraph-font primary-text mb-2">
              {`${t('find_provider.gender')} - `}
              {['Male', 'Female'].includes(doctorDetails.Gender)
                ? doctorDetails.Gender
                : 'Unknown'}
            </p>
            <p className="paragraph-font primary-text mb-2">
              {`${t('find_provider.age')} - `}
              {doctorDetails.Age
                ? `${doctorDetails.Age} Years Old`
                : noDataMessage}
            </p>
            <p className="paragraph-font primary-text mb-2">
              {`${t('find_provider.email')} -`}
              {doctorDetails.EmailAddress ? (
                <a
                  className="secondary-2 pl-2"
                  href={`mailto:${doctorDetails.EmailAddress}`}
                >
                  {doctorDetails.EmailAddress}
                </a>
              ) : doctorDetails?.DoctorAfflFacilities[addressIndex]
                  ?.EmailAddress ? (
                <a
                  className="secondary-2"
                  href={`mailto:${doctorDetails?.DoctorAfflFacilities[addressIndex]?.EmailAddress}`}
                >
                  {
                    doctorDetails?.DoctorAfflFacilities[addressIndex]
                      ?.EmailAddress
                  }
                </a>
              ) : (
                noDataMessage
              )}
            </p>
            <p className="paragraph-font primary-text">
              {`${t('find_provider.website')} - `}
              {doctorDetails?.DoctorAfflFacilities[addressIndex]?.Website &&
              doctorDetails?.DoctorAfflFacilities[addressIndex]?.Website !=
                null ? (
                <a
                  className="secondary-2 text-break"
                  target={'_blank'}
                  rel="noopener noreferrer"
                  href={
                    doctorDetails?.DoctorAfflFacilities[addressIndex]?.Website
                  }
                >
                  {doctorDetails?.DoctorAfflFacilities[addressIndex]?.Website}
                </a>
              ) : (
                noDataMessage
              )}
            </p>
            <p className="paragraph-font primary-text mb-0">
              {t('find_provider.language_spoken')}
            </p>
            <p>
              {doctorDetails.SpokenLanguages &&
                doctorDetails.SpokenLanguages.join(' | ')}
            </p>
          </div>
        </Col>
      </Row>
      <div className="mobile-provider-details w-100 p-2 py-4 py-md-2">
        <Accordion defaultActiveKey={activeId} role="tablist">
          <div
            className={`panel-wrap provider-details-info mb-3 w-100 ${
              activeId === '0' ? ' active-panel' : ''
            }`}
          >
            <div className="panel-header">
              <Accordion.Toggle
                onClick={() => toggleActive('0')}
                className="panel-toggle text-left w-100"
                variant="link"
                eventKey="0"
                role="tab"
                aria-expanded={activeId === '0'}
                aria-label={`${t('find_provider.provider_information')}`}
              >
                <span className="accordion-image">
                  {activeId === '0' ? (
                    <AccordionDownArrow className="acc-arrow" />
                  ) : (
                    <AccordionUpArrow className="acc-arrow" />
                  )}
                </span>
                {t('find_provider.provider_information')}
              </Accordion.Toggle>
            </div>

            <Accordion.Collapse eventKey="0">
              <div className="panel-body provider-information-accordion">
                <ProviderInformationAccordion
                  locationHandler={locationHandler}
                  doctorDetails={doctorDetails}
                  addressIndex={addressIndex}
                  makeAffiliationsActive={makeAffiliationsActive}
                  affiliatedDoctorsAddress={affiliatedDoctorsAddress}
                />
              </div>
            </Accordion.Collapse>
          </div>

          <div
            className={`panel-wrap provider-affiliation-info w-100 ${
              activeId === '1' ? ' active-panel' : ''
            }`}
          >
            <div className="panel-header">
              <Accordion.Toggle
                onClick={() => toggleActive('1')}
                className="panel-toggle text-left w-100"
                variant="link"
                eventKey="1"
                ref={affiliationsAccordion}
                role="tab"
                aria-expanded={activeId === '1'}
                aria-label={`${t('find_provider.affiliations')}, ${t(
                  'find_provider.awards_and_recognitions',
                )}
                }`}
              >
                <span className="accordion-image">
                  {activeId === '1' ? (
                    <AccordionDownArrow className="acc-arrow" />
                  ) : (
                    <AccordionUpArrow className="acc-arrow" />
                  )}
                </span>
                {t('find_provider.affiliations')},{' '}
                {t('find_provider.awards_and_recognitions')}
              </Accordion.Toggle>
            </div>
            <Accordion.Collapse eventKey="1">
              <div className="affiliated-doctors-accordion">
                <AffiliationsAwardsAccordion
                  affiliatedDoctorsHandler={affiliatedDoctorsHandler}
                  doctorDetails={doctorDetails}
                  focusRef={affiliationTabRef}
                />
              </div>
            </Accordion.Collapse>
          </div>
        </Accordion>
      </div>
    </>
  );
};

export default ProviderDetailsMobile;
